// extracted by mini-css-extract-plugin
export default {"wrapper":"mWRx_n"};